import React from 'react';
import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import AuthorizationProvider from "./_helper/Authorization/AuthorizationProvider";
import EmailVerificationProvider from "./_helper/EmailVerification/EmailVerificationProvider";
import WalletProvider from './Application/Application/Wallet/Context/WalletProvider';

const App = () => (
    <div className='App'>
        <AuthorizationProvider>
            <EmailVerificationProvider>
                <CustomizerProvider>
                    <AnimationThemeProvider>
                        <WalletProvider>
                            <Routers/>
                        </WalletProvider>
                    </AnimationThemeProvider>
                </CustomizerProvider>
            </EmailVerificationProvider>
        </AuthorizationProvider>
    </div>
);

export default App;
